import { useContent } from '../../../../hooks/use-server-content';

export interface SyncMapsVehicleCardProps {
    hide: boolean;
    syncLabel: string;
    currentVersionLabel: string;
    syncGenerationLabel: string;
    generationNumberLabel: string;
    vinLabel: string;
    syncVersionLabel: string;
    updatesLabel: string;
    syncUpdateLabel: string;
    updateAvailableLabel: string;
    mapsLabel: string;
    mobileAccordionCollapseSubtitle: string;
    mobileAccordionExpandSubtitle: string;
    softwareGenerationLabel: string;
    digitalExperienceLabel: string;
}

export const useSyncMapsVehicleContent = (
    name: string
): SyncMapsVehicleCardProps | null => {
    const [content, getValueByName] = useContent('sync', name);
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide) {
            contentFragment = null;
        }
    }

    return contentFragment as SyncMapsVehicleCardProps;
};
